import { handleActions } from 'redux-actions';
import immutable from 'immutability-helper';
import { ActionTypes } from '../constants';
// import { ActionTypes } from '../constants';

const initialState = {
    status: 'idle',
    sessionList: [
        {
            id: 1,
            name: 'Sales Session',
            status: 'connected',
            phone: '628123456789',
            lastActive: '2 menit lalu',
            createdAt: '2024-01-15T10:00:00Z',
        },
        {
            id: 2,
            name: 'Support Session',
            status: 'connecting',
            phone: '-',
            lastActive: '10 menit lalu',
            createdAt: '2024-01-15T09:30:00Z',
        },
        {
            id: 3,
            name: 'Marketing Session',
            status: 'disconnected',
            phone: '-',
            lastActive: '1 jam lalu',
            createdAt: '2024-01-15T08:00:00Z',
        },
    ],
    currentSession: null,
    sessionName: '',
    isSessionLoading: false,
    error: null,
    response: Object.assign({}),
};

export const sessionState = { ...initialState };

export default {
    wa_session: handleActions(
        {
            // Reset state
            [ActionTypes.RESET_SESSION_STATE]: state => immutable(state, {
                status: { $set: 'idle' },
                sessionList: { $set: initialState.sessionList },
                currentSession: { $set: null },
                sessionName: { $set: '' },
                isSessionLoading: { $set: false },
                error: { $set: null },
                response: { $set: {} },
            }),

            // Loading
            [ActionTypes.SESSION_LOADING]: state => immutable(state, {
                status: { $set: 'loading' },
                isSessionLoading: { $set: true },
                error: { $set: null },
            }),

            // Success
            [ActionTypes.SESSION_SUCCESS]: (state, { payload }) => immutable(state, {
                status: { $set: 'success' },
                isSessionLoading: { $set: false },
                response: { $set: payload },
            }),

            // Failed
            [ActionTypes.SESSION_FAILED]: (state, { payload }) => immutable(state, {
                status: { $set: 'error' },
                isSessionLoading: { $set: false },
                error: { $set: payload },
            }),

            // Add session
            [ActionTypes.SESSION_ADD]: (state, { payload }) => {
                const newSession = {
                    id: state.sessionList.length + 1,
                    ...payload,
                    status: 'disconnected',
                    phone: '-',
                    lastActive: 'Baru dibuat',
                    createdAt: new Date().toISOString(),
                };
                return immutable(state, {
                    sessionList: { $push: [newSession] },
                    sessionName: { $set: '' },
                    status: { $set: 'success' },
                });
            },

            // Update session status
            [ActionTypes.SESSION_UPDATE_STATUS]: (state, { payload }) => {
                const { id, status, phone } = payload;
                const index = state.sessionList.findIndex(s => s.id === id);
                if (index === -1) return state;

                const updates = {
                    status: { $set: status || state.sessionList[index].status },
                    lastActive: { $set: 'Baru saja' },
                };
                if (phone) {
                    updates.phone = { $set: phone };
                }

                return immutable(state, {
                    sessionList: {
                        [index]: { $merge: updates },
                    },
                });
            },

            // Delete session
            [ActionTypes.SESSION_DELETE]: (state, { payload }) => {
                const index = state.sessionList.findIndex(s => s.id === payload);
                if (index === -1) return state;
                return immutable(state, {
                    sessionList: { $splice: [[index, 1]] },
                });
            },

            // Set current session
            [ActionTypes.SESSION_SET_CURRENT]: (state, { payload }) => immutable(state, {
                currentSession: { $set: payload },
            }),

            // Set session name
            [ActionTypes.SESSION_SET_NAME]: (state, { payload }) => immutable(state, {
                sessionName: { $set: payload },
            }),
        },
        initialState
    ),
};